import React, { cloneElement, useContext } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';

function NRNoData({ noDataTitle }) {
  const { drawerTitle } = useContext(FiltersContext);
  const titleElement = Array.isArray(drawerTitle) ? drawerTitle.at(-1) : null;
  const showEntity = React.isValidElement(titleElement);

  const clonedTitle = showEntity
    ? cloneElement(titleElement, {
        variant: 'body2',
        mt: 0,
        color: 'text.primary',
        component: 'span',
        sx: { px: 0.5 }
      })
    : null;

  return (
    <Box
      sx={{
        color: 'text.secondary',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: 595,
        display: 'flex'
      }}
    >
      <Typography variant="body2" component="span" sx={{ pl: 0.5 }}>
        No {noDataTitle?.toLowerCase()}
        {showEntity && ' for'}
      </Typography>
      {clonedTitle}
      <Typography variant="body2" component="span">
        {' '}
        were found.
      </Typography>
    </Box>
  );
}

export default NRNoData;
